<div class="flex flex-col w-full gap-4 lg:py-4 p-2 lg:p-0 pb-10 lg:pb-0">
  <div [ngClass]="{ mobile: 'w-full', 'w-100 ml-auto': !mobile }">
    <div class="text-general-title px-3">Tu Tienda</div>
    <div class="w-full">
      <div class="mx-4 flex gap-4 justify-end items-center">
        <app-input-general-select
          class="w-full"
          [label]="''"
          [formControlGeneral]="address"
          [arrayData]="locationDetailArray"
          [inputSelect]="{ value: '', description: 'BusinessName' }"
        ></app-input-general-select>
      </div>
    </div>
  </div>

  @if (productsFavorites.length) {
    <div class="px-1 w-full 2xl:w-[95%] mx-auto">
      <div [ngClass]="{ 'general-box': !mobile, 'flex flex-col gap-1': mobile }">
        <div class="text-general-title px-3">Volver a pedir</div>

        <div class="flex gap-3 p-2 scrol-general-x">
          @for (product of productsFavorites; track product.Id) {
            <app-card-product
              [added]="productInCar[product.Id]?.added || false"
              [product]="product"
            >
            </app-card-product>
          }
        </div>
      </div>
    </div>
  }

  <div class="px-1 w-full 2xl:w-[95%] mx-auto">
    <div [ngClass]="{ 'general-box': !mobile, 'flex flex-col gap-1': mobile }">
      <div class="flex gap-1 scroll-invisible">
        <button
          class="button-general shrink-0! py-4"
          matButton="filled"
          [ngClass]="{
            'h-12!': !mobile,
            'h-14!': mobile,
            'button-general': buttonFilter === '',
            'button-general-border': buttonFilter !== '',
          }"
          (click)="getProducts(0); buttonFilter = ''"
        >
          Todos los Productos
        </button>
        <button
          class="button-general-border shrink-0! py-4 w-40"
          matButton="filled"
          [ngClass]="{
            'h-12!': !mobile,
            'h-14!': mobile,
            'button-general': buttonFilter === 'Paletas',
            'button-general-border': buttonFilter !== 'Paletas',
          }"
          (click)="getProducts(0, 'SupplyType', 'Paletas'); buttonFilter = 'Paletas'"
        >
          Paletas
        </button>
      </div>

      <div class="grid grid-flow-col gap-2 gap-y-3 grid-rows-2 p-2 scrol-general-x">
        @for (card of productsDataSource.connect() | async; track card.Id) {
          <app-card-product
            [added]="productInCar[card.Id]?.added || false"
            [small]="mobile"
            [product]="card"
          ></app-card-product>
        }
      </div>

      <mat-paginator
        [length]="totalItems"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        (page)="onPageChange($event)"
        [pageSizeOptions]="[8, 16, 52]"
      >
      </mat-paginator>
    </div>
  </div>
</div>

<app-load-general [load]="isLoading || isLoadingTicket"></app-load-general>
